import { Box } from '@hivebrite/design-system/Box';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';

export const FreeTrailPeriodBadge = ({ mt = 2, mb = 0, withText }) => (
  <Box
    color="orange"
    fontWeight="semibold"
    alignItems="center"
    mt={mt}
    mb={mb}
    data-testid="free-trial-badge"
  >
    <Box color="inherit" pr={2}>
      <FontAwesomeIcon
        height="16px"
        iconName="gift"
        iconType={CATEGORIES.SOLID}
      />
    </Box>
    {withText && (
      <Box font="body-regular-asphalt">
        {s__('Memberships|Free trial period')}
      </Box>
    )}
  </Box>
);
